export type AccountAccessPresetKey = "viewer" | "operator" | "admin";

export type AccountAccessPreset = {
  key: AccountAccessPresetKey;
  label: string;
  description: string;
  role: "client" | "customer" | "admin";
  can_view_opportunity_engine: boolean;
  can_view_competitive: boolean;
  can_view_local: boolean;
  can_view_retail: boolean;
};

export const ACCOUNT_ACCESS_PRESETS: AccountAccessPreset[] = [
  {
    key: "viewer",
    label: "Viewer",
    description: "Read-only report access. Best for demo viewers, executives, or light client access.",
    role: "client",
    can_view_opportunity_engine: false,
    can_view_competitive: true,
    can_view_local: false,
    can_view_retail: false,
  },
  {
    key: "operator",
    label: "Operator",
    description: "Customer operator access with Opportunity Engine enabled.",
    role: "customer",
    can_view_opportunity_engine: true,
    can_view_competitive: true,
    can_view_local: false,
    can_view_retail: false,
  },
  {
    key: "admin",
    label: "Account Admin",
    description: "Trusted account admin access.",
    role: "admin",
    can_view_opportunity_engine: true,
    can_view_competitive: true,
    can_view_local: true,
    can_view_retail: true,
  },
];

export function getAccountAccessPreset(key: AccountAccessPresetKey) {
  return ACCOUNT_ACCESS_PRESETS.find((preset) => preset.key === key) || ACCOUNT_ACCESS_PRESETS[0];
}
